var map = {
	"./busd.svg": 1999,
	"./crypto-pending.png": 2000,
	"./crypto-reject.png": 2001,
	"./crypto-success.png": 2002,
	"./direpay.svg": 2003,
	"./trx.svg": 2004,
	"./usdc.svg": 2005,
	"./usdt.svg": 2006
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 153;